import styled from "styled-components"

export const StyledContainer: any = styled.div`
	margin: 0 auto;
	padding: 0 32px;
	width: 100%;
	max-width: ${({ width }: any) => `${width || 1080}px`};
`
